/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CapsulePartyDto } from '../../models/capsule-party-dto';

export interface MgmtCustomerControllerCapsuleShow$Params {
  id: number;
}

export function mgmtCustomerControllerCapsuleShow(http: HttpClient, rootUrl: string, params: MgmtCustomerControllerCapsuleShow$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CapsulePartyDto>>> {
  const rb = new RequestBuilder(rootUrl, mgmtCustomerControllerCapsuleShow.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CapsulePartyDto>>;
    })
  );
}

mgmtCustomerControllerCapsuleShow.PATH = '/api/mgmt-customers/capsule/show';
